import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_TECHNICAL, ROLE_READ_ONLY } = ROLES;

const ALLOWED_ROLES_CREATE_PAYMENT_BUTTON = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_TECHNICAL, ROLE_READ_ONLY];

export function canCreatePaymentButton(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CREATE_PAYMENT_BUTTON);
}
